import React from 'react';
import { LabelReview } from './pages/LabelReview';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50 flex" data-id="element-0">
      <Sidebar data-id="element-1" />
      <div className="flex-1 ml-60" data-id="element-2">
        <Header data-id="element-3" />
        <LabelReview data-id="element-4" />
      </div>
    </div>;
}